import { render, staticRenderFns } from "./StaffScanTemperatureWithBarCode.vue?vue&type=template&id=727d2cf5&scoped=true"
import script from "./StaffScanTemperatureWithBarCode.vue?vue&type=script&lang=js"
export * from "./StaffScanTemperatureWithBarCode.vue?vue&type=script&lang=js"
import style0 from "./StaffScanTemperatureWithBarCode.vue?vue&type=style&index=0&id=727d2cf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727d2cf5",
  null
  
)

export default component.exports